import React from 'react';
import { AgGridReact } from 'ag-grid-react';


export type TypedAgGridReactProps<TData> = {
  readonly rowData?: readonly TData[] | TData[] | null;
  readonly columnDefs?: ReadonlyArray<object>;
  readonly defaultColDef?: object;
  readonly animateRows?: boolean;
  readonly suppressRowClickSelection?: boolean;
  readonly onGridReady?: (event: {
    readonly api: {
      readonly hideOverlay: () => void;
      readonly showLoadingOverlay: () => void;
      readonly exportDataAsCsv: () => void;
    };
    readonly columnApi: unknown;
  }) => void;
  readonly overlayNoRowsTemplate?: string;
  readonly pagination?: boolean;
  readonly paginationPageSize?: number;
  readonly onColumnMoved?: () => void;
  readonly onColumnResized?: () => void;
  readonly onFilterChanged?: () => void;
  readonly onSortChanged?: () => void;
};

type TypedAgGridReactComponent = <TData>(
  props: TypedAgGridReactProps<TData> & {
    readonly ref?: React.Ref<AgGridReact<TData>>;
  },
) => React.ReactElement | null;

export const TypedAgGridReact =
  AgGridReact as unknown as TypedAgGridReactComponent;
